import type { ContentType } from "@/types/CourseTypes";
import { TvMinimalPlay, BookOpen, NotebookPen } from "lucide-react";

export const CONTENT_TYPE_META: Record<ContentType, { label: string; icon: React.ReactNode; color: string }> = {
    VIDEO: {
        label: "Video",
        icon: <TvMinimalPlay className="h-3 w-3" />,
        color: "text-pink-400 bg-pink-400/10",
    },
    TEXT: {
        label: "Reading",
        icon: <BookOpen className="h-3 w-3" />,
        color: "text-amber-600 bg-amber-600/10",
    },
    QUIZ: {
        label: "Quiz",
        icon: <NotebookPen className="h-3 w-3" />,
        color: "text-indigo-600 bg-indigo-600/10",
    },
};
